export default "__VITE_ASSET__cb26fa16__"